import React, { useState, useEffect } from "react";

export default function AdminIuranLainnya({
  supabase,
  styles
}) {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadData = async () => {

    setLoading(true);

    // Gunakan pagination karena default Supabase hanya 1000 record
    const PAGE_SIZE = 1000;
    let allData = [];
    let from = 0;
    let hasMore = true;
    let queryError = null;
    while (hasMore) {
      const { data: hasil, error } = await supabase
        .from("iuran_lainnya")
        .select("id, nomor_rumah, nama_warga, jenis_iuran, nominal, status, bukti_transfer, bukti_foto, created_at")
        .order("created_at", { ascending:false })
        .range(from, from + PAGE_SIZE - 1);
      if (error) { queryError = error; break; }
      allData = allData.concat(hasil || []);
      hasMore = (hasil || []).length === PAGE_SIZE;
      from += PAGE_SIZE;
    }

    if(queryError){
      alert(queryError.message);
    }else{
      console.log("[AdminIuranLainnya] loaded", allData.length, "records");
      setData(allData);
    }

    setLoading(false);

  };

  useEffect(()=>{

    loadData();

    const kanal = supabase
      .channel("perubahan_iuran_lainnya_admin")
      .on("postgres_changes", { event: "*", schema: "public", table: "iuran_lainnya" }, (payload) => {
        console.log("[Realtime] perubahan_iuran_lainnya_admin:", payload);
        loadData();
      })
      .subscribe();

    return () => {
      supabase.removeChannel(kanal);
    };

  },[]);
  const verifikasi = async (item) => {

    const { data, error } = await supabase
    .from("iuran_lainnya")
    .update({
      status: "Disetujui",
      tanggal_verifikasi: new Date().toISOString(),
      diverifikasi_oleh: "Admin RT"
    })
    .eq("id", item.id)
    .select();
  
  console.log("HASIL UPDATE :", data);
  console.log("ERROR UPDATE :", error);

    if (error) {
      alert(error.message);
      return;
    }

    await loadData();

    alert("Iuran berhasil diverifikasi.");

  };
  return (
    <div>

      <div
        style={{
          fontSize: "19px",
          fontWeight: "bold",
          color: "#1E5631",
          marginBottom: "14px"
        }}
      >
        Verifikasi Iuran Lainnya
      </div>

     {loading ? (

  <div></div>

) : data.length === 0 ? (
  
        <div
          style={{
            background: "#fff",
            padding: "20px",
            borderRadius: "10px",
            textAlign: "center"
          }}
        >
          Belum ada pengajuan iuran.
        </div>

      ) : (

        data.map((item) => (

          <div
            key={item.id}
            style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "16px",
              marginBottom: "14px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
            }}
          >

            <div><b>Rumah :</b> {item.nomor_rumah}</div>
            <div><b>Nama :</b> {item.nama_warga}</div>
            <div><b>Jenis :</b> {item.jenis_iuran}</div>
            <div><b>Nominal :</b> Rp {Number(item.nominal).toLocaleString("id-ID")}</div>
            <div style={{marginTop:"8px"}}>

  <b>Status :</b>

  <span
    style={{
      marginLeft:"8px",
      padding:"4px 10px",
      borderRadius:"20px",
      fontWeight:"bold",
      background:
        item.status === "Disetujui"
          ? "#DCFCE7"
          : "#FEF3C7",
      color:
        item.status === "Disetujui"
          ? "#166534"
          : "#92400E"
    }}
  >
    {item.status}
  </span>

</div>

            {(item.bukti_transfer || item.bukti_foto) && (
              <div style={{ marginTop: "10px" }}>
                <a
                  href={item.bukti_transfer || item.bukti_foto}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  📷 Lihat Bukti Transfer
                </a>
              </div>
            )}

            {String(item.status || "").toLowerCase() !== "disetujui" && (
              <button
                onClick={() => verifikasi(item)}
                style={{
                  ...styles.btnPrimary,
                  marginTop: "12px"
                }}
              >
                ✅ Setujui
              </button>
            )}

          </div>

        ))

      )}

    </div>
  );

}